import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getProviderProfileOptions } from '../../../../../../../api'
import { EMPTY_LIST } from '../../../../../../../constants/common'
import { getItemsFromIdwellApiResponse } from '../../../../../../../utils/api'
import { FieldStackedLabel } from '../../../../../../Field'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../../../../Form'
import { FormikField } from '../../../../../../Formik'
import { toSelectListItems } from '../../../../../../Request'
import {
  getAsyncSelectShowSelectedApiParamIdPK,
  useInitiallyOpenSelect,
} from '../../../../../../Select'
import { UserMultiSelect } from '../../../../../../User'
import { RequestProfileWidgetSendNotificationField } from '../../../../RequestProfileWidgetSendNotificationField'
import {
  REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_IS_PROVIDERS_INVITATION,
  REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS,
  REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS_COMMENT,
} from '../../../RequestProfileWidgetProviders.constants'

import * as styles from '../RequestProfileWidgetProvidersFormFields.module.css'

import ProviderIcon from '../../../../../../../icons/provider.svg'

function SelectedProvidersField({ requestId }) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const selectStatesRef = useInitiallyOpenSelect(
    values[REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS].length === 0
  )

  return (
    <div className={styles.section}>
      <FormFieldsContainer>
        <FormikField
          multi
          Component={FormFieldSelectNG}
          EntityIcon={ProviderIcon}
          Field={FieldStackedLabel}
          Select={UserMultiSelect}
          controlProps={{
            contentProps: {
              inputProps: {
                placeholder: t('RequestProfile.ProviderSelectPlaceholderKey'),
              },
            },
          }}
          emptyValue={EMPTY_LIST}
          fieldComponentProps={{
            label: t('RequestProfile.ProvidersSelectedProvidersTitleKey', {
              count:
                values[REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS]
                  .length,
            }),
          }}
          getData={getProviderProfileOptions}
          getDataItems={getItemsFromIdwellApiResponse}
          getShowSelectedApiParam={getAsyncSelectShowSelectedApiParamIdPK}
          name={REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS}
          selectStatesRef={selectStatesRef}
          toPreparedItems={toSelectListItems}
        />
        <RequestProfileWidgetSendNotificationField
          checkboxFieldName={
            REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_IS_PROVIDERS_INVITATION
          }
          commentFieldName={
            REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS_COMMENT
          }
          disabledTooltipKey='Modal.SendNotificationEmptyAssigneesTypeDisabledCheckboxTooltipKey'
          fieldName={REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS}
          requestId={requestId}
        />
      </FormFieldsContainer>
    </div>
  )
}

export default SelectedProvidersField
